import { Action } from '../../definitions/types';
import * as Actions from '../actions/actions-consts';

export interface UserState {
  idToken: string;
}

const initialState = {
  idToken: '',
};

export default function user(
  state: UserState = initialState,
  action: Action<string>
): UserState {
  switch (action.type) {
    case Actions.SET_USER_ID_TOKEN:
      return Object.assign({}, state, {
        idToken: action.payload,
      });
    default:
      return state;
  }
}
